import axios from "axios";
let adultDep = [];
let childrenDep = [];
let departments = [];
let general = [];
let dentistry = [];
let chosenDepartment = [];
const doctorCardTemplate = document.querySelector("[data-doctor-template]");
const departmentTemplate = document.querySelector("[data-department-template]");
const departmentContainer = document.querySelector(
    ".appointment__department-container"
);
const departmentsWrapper = document.querySelector(".appointment__wrapper");
const specialitiesContainer = document.querySelector(
    ".appointment__specialities"
);
const specialistsContainer = document.querySelector(
    ".appointment__specialists"
);
const specialitiesWrapper = document.querySelector(
    ".appointment__specialities-container"
);

axios
    .get("/appointment/specialties?clinic_id=1")
    .then((response) => {
        const res = response.data.data;
        adultDep = res
            .filter(function (dep) {
                return dep.departmentId === 1;
            })
            .map((d) => {
                return {
                    id: d.id,
                    name: d.name,
                    departmentName: d.departmentName || "Без названия",
                };
            });

        childrenDep = res
            .filter(function (dep) {
                return dep.departmentId === 2;
            })
            .map((d) => {
                return {
                    id: d.id,
                    name: d.name,
                    departmentName: d.departmentName || "Без названия",
                };
            });
        dentistry = res
            .filter(function (dep) {
                return dep.departmentId === 3;
            })
            .map((d) => {
                return {
                    id: d.id,
                    name: d.name,
                    departmentName: d.departmentName || "Без названия",
                };
            });
        general = res
            .filter(function (dep) {
                return dep.departmentId === 4;
            })
            .map((d) => {
                return {
                    id: d.id,
                    name: d.name,
                    departmentName: d.departmentName || "Без названия",
                };
            });
        departments.push(adultDep, childrenDep, general, dentistry);
        departments.map((dep) => {
            const depCard =
                departmentTemplate.content.cloneNode(true).children[0];
            const depHeader = depCard.querySelector("[data-department-header]");

            // Проверка на существование данных
            if (!dep[0] || typeof dep[0].departmentName === 'undefined') {
                return;
            }

            depHeader.textContent = dep[0].departmentName;
            depCard.setAttribute("id", `${dep[0].id}`);
            depHeader.classList.add("appointment__department");
            departmentContainer.append(depCard);

            dep.map((el) => {
                const specialityCard =
                    departmentTemplate.content.cloneNode(true).children[0];
                const specialityHeader = specialityCard.querySelector(
                    "[data-department-header]"
                );
                specialityCard.classList.add("appointment__speciality");
                specialityHeader.textContent = el.name;
                specialityCard.setAttribute("id", `${el.id}`);

                depCard.append(specialityCard);
                specialityCard.addEventListener("click", () => {
                    const id = specialityCard.getAttribute("id");
                    getSpecialists(id);
                    departmentsWrapper.style.display = "none";
                    specialitiesWrapper.style.display = "block";
                });
            });
        });
    })
    .catch((error) => console.log(error));

const getSpecialists = (id) => {
    axios
        .get(`/appointment/doctors?clinic_id=1&specialty_id=${id}`)
        .then((response) => {
            const res = response.data.data;
            res.map((specialist) => {
                const specialistCard =
                    departmentTemplate.content.cloneNode(true).children[0];
                const specialistHeader = specialistCard.querySelector(
                    "[data-department-header]"
                );
                specialistHeader.textContent = specialist.name;
                specialistCard.setAttribute("id", `${specialist.id}`);
                specialistsContainer.append(specialistCard);
            });
        })
        .catch((error) => console.log(error));
};
